module.exports = __webpack_public_path__ + "img/sun.266cb474.svg";